import { useState } from "react";

const useVerificationObjection = () => {
    const [objections, setObjections] = useState([]);
    function handleObjections(e, item, section, category, resolved) {
        const existingObjection = objections.find((objection) => objection.item === item);
        if (existingObjection) {
            const updatedObjections = objections.map((objection) => {
                if (objection.item === item) {
                    return { ...objection, description: e ? e.target.value : "", resolved };
                }
                return objection;
            });
            setObjections(updatedObjections);
        } else {
            const objectionObject = {
                description: e ? e.target.value : "",
                section,
                item,
                category,
                resolved,
            };
            setObjections([...objections, objectionObject]);
        }
    }
    return { objections, handleObjections };
};

export default useVerificationObjection;
